import {FailedArtifactsController} from './failed_artifacts.controller';

function failedArtficatslConfig($stateProvider) {
    $stateProvider
        .state('settings.failure_messages', {
            url: '/system_messages',
            template: require('./failed_artifacts.html'),
            controller: 'FailedArtifactsController as FailedArtifacts',
            params: {
                title: 'System Messages'
            }
        });
}

export default angular.module(' analysis_errors', [])
    .config(failedArtficatslConfig)
    .controller('FailedArtifactsController', FailedArtifactsController);



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/failed_artifacts/failed_artifacts.module.js